import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Share2, Link2, Check } from 'lucide-react';
import { appUrl } from '../utils/appUrl';
import PreferredSourceButton from './PreferredSourceButton';
import StoreBadges from './StoreBadges';

const SHARE_URL = 'https://www.recalibratepain.com';
const SHARE_TITLE = 'Recalibrate - the all-in-one health ecosystem for chronic illness, chronic pain, fibromyalgia, long COVID and more';
const SHARE_BODY = 'I thought you might find this helpful - Recalibrate is the all-in-one health ecosystem for chronic illness, chronic pain, fibromyalgia, long COVID and more.\n\nhttps://www.recalibratepain.com';

const SHARE_TARGETS = [
  {
    name: 'WhatsApp',
    test: 'whatsapp',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
    ),
    href: `https://wa.me/?text=${encodeURIComponent(SHARE_TITLE + ' ' + SHARE_URL)}`,
    hover: 'hover:bg-[#25D366] hover:border-[#25D366]',
  },
  {
    name: 'X',
    test: 'x',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
    ),
    href: `https://x.com/intent/tweet?text=${encodeURIComponent(SHARE_TITLE)}&url=${encodeURIComponent(SHARE_URL)}`,
    hover: 'hover:bg-black hover:border-black',
  },
  {
    name: 'LinkedIn',
    test: 'linkedin',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
    ),
    href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(SHARE_URL)}`,
    hover: 'hover:bg-[#0077b5] hover:border-[#0077b5]',
  },
  {
    name: 'Facebook',
    test: 'facebook',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
    ),
    href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SHARE_URL)}`,
    hover: 'hover:bg-[#1877F2] hover:border-[#1877F2]',
  },
  {
    name: 'Email',
    test: 'email',
    icon: <Mail className="w-4 h-4" />,
    href: `mailto:?subject=${encodeURIComponent('Check out Recalibrate')}&body=${encodeURIComponent(SHARE_BODY)}`,
    hover: 'hover:bg-gray-600 hover:border-gray-600',
  },
];

export default function Footer() {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(SHARE_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const input = document.createElement('input');
      input.value = SHARE_URL;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <footer data-testid="main-footer" className="py-12 px-4 sm:px-6 bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto">
        {/* Share CTA - clearly labelled as sharing */}
        <div className="bg-gradient-to-r from-purple-900/50 to-indigo-900/50 border border-purple-700/30 rounded-2xl p-5 sm:p-6 mb-10" data-testid="footer-share-cta">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-purple-500/20 border border-purple-400/30 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5">
                <Share2 className="w-5 h-5 text-purple-300" />
              </div>
              <div>
                <p className="font-bold text-white text-base">Know someone living with chronic illness or chronic pain?</p>
                <p className="text-sm text-purple-200/70 mt-0.5">Share Recalibrate with them - the all-in-one health ecosystem. Free to start.</p>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              {SHARE_TARGETS.map((t) => (
                <a
                  key={t.name}
                  href={t.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={`Share on ${t.name}`}
                  data-testid={`footer-share-${t.test}`}
                  className={`w-9 h-9 rounded-xl bg-white/10 border border-white/20 text-white/80 flex items-center justify-center transition-all hover:text-white ${t.hover}`}
                >
                  {t.icon}
                </a>
              ))}
              <button
                type="button"
                onClick={copyLink}
                title="Copy link"
                data-testid="footer-share-copy"
                className="w-9 h-9 rounded-xl bg-white/10 border border-white/20 text-white/80 flex items-center justify-center transition-all hover:bg-purple-500 hover:border-purple-500 hover:text-white"
              >
                {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-10">
          <div>
            <p className="text-xs font-bold tracking-[0.18em] uppercase text-purple-300 mb-3">Product</p>
            <ul className="space-y-2 text-sm text-purple-100/70">
              <li><a href={appUrl('/', 'footer-app-link', 'footer')} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">App</a></li>
              <li><Link to="/features" className="hover:text-white transition-colors">Features</Link></li>
              <li><a href={appUrl('/pricing', 'footer-pricing-link', 'footer')} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Pricing</a></li>
              <li><Link to="/shop" className="hover:text-white transition-colors">Shop</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold tracking-[0.18em] uppercase text-purple-300 mb-3">Learn</p>
            <ul className="space-y-2 text-sm text-purple-100/70">
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/portals" className="hover:text-white transition-colors">Health Portals</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold tracking-[0.18em] uppercase text-purple-300 mb-3">Research Portals</p>
            <ul className="space-y-2 text-sm text-purple-100/70">
              <li><a href="/portals/fibromyalgia/" className="hover:text-white transition-colors">Fibromyalgia</a></li>
              <li><a href="/portals/long-covid/" className="hover:text-white transition-colors">Long COVID &amp; ME/CFS</a></li>
              <li><a href="/portals/css/" className="hover:text-white transition-colors">Central Sensitisation</a></li>
              <li><a href="/portals/adhd/" className="hover:text-white transition-colors">ADHD</a></li>
              <li><a href="/portals/arthritis/" className="hover:text-white transition-colors">Arthritis</a></li>
              <li><a href="/portals/ms/" className="hover:text-white transition-colors">Multiple Sclerosis</a></li>
              <li><a href="/portals/arachnoiditis/" className="hover:text-white transition-colors">Arachnoiditis</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold tracking-[0.18em] uppercase text-purple-300 mb-3">Company</p>
            <ul className="space-y-2 text-sm text-purple-100/70">
              <li><Link to="/clinicians" className="hover:text-white transition-colors">For Clinicians</Link></li>
              <li><Link to="/partners" className="hover:text-white transition-colors">Partners</Link></li>
              <li><a href="mailto:info@recalibratepain.com" data-testid="footer-contact-link" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new Event('recalibrate:open-helpdesk')); }} className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10 space-y-6">
          {/* App store badges - Google Play live */}
          <div className="flex w-full justify-center">
            <StoreBadges align="center" testidPrefix="footer-store" />
          </div>

          {/* Google Preferred Sources - official button */}
          <div className="flex w-full justify-center">
            <PreferredSourceButton theme="dark" className="py-1" testIdPrefix="footer-preferred-source" />
          </div>

          {/* Credits - full-width above Follow Us so the feedback widget never covers it */}
          <div className="text-center" data-testid="footer-credits">
            <p className="text-xs text-purple-300/70">Recalibrate. Smarter Health and Pain Technology</p>
            <p className="text-[11px] text-purple-300/40 mt-1">© 2025–{new Date().getFullYear()} Recalibrate. Your intelligent health companion.</p>
            <p className="text-[11px] text-purple-300/50 mt-1">
              <a href="mailto:info@recalibratepain.com" className="hover:text-white transition-colors">info@recalibratepain.com</a>
            </p>
          </div>

          {/* Follow us - real social profiles, centered below credits */}
          <div className="flex flex-col items-center gap-3" data-testid="footer-follow">
            <span className="text-xs font-bold tracking-[0.18em] uppercase text-purple-300">Follow us</span>
            <div className="flex items-center gap-2">
                <a
                  href="https://www.instagram.com/recalibrateapp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Recalibrate on Instagram"
                  data-testid="footer-follow-instagram"
                  className="w-9 h-9 rounded-xl bg-white/10 border border-white/20 text-white/80 flex items-center justify-center transition-all hover:text-white hover:bg-gradient-to-br hover:from-[#feda75] hover:via-[#d62976] hover:to-[#4f5bd5] hover:border-transparent"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                </a>
                <a
                  href="https://x.com/RecalibrateApp"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Recalibrate on X"
                  data-testid="footer-follow-x"
                  className="w-9 h-9 rounded-xl bg-white/10 border border-white/20 text-white/80 flex items-center justify-center transition-all hover:bg-black hover:text-white hover:border-black"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/recalibrate-app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Recalibrate on LinkedIn"
                  data-testid="footer-follow-linkedin"
                  className="w-9 h-9 rounded-xl bg-white/10 border border-white/20 text-white/80 flex items-center justify-center transition-all hover:bg-[#0077b5] hover:text-white hover:border-[#0077b5]"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                </a>
                <a
                  href="mailto:info@recalibratepain.com"
                  title="Email Recalibrate"
                  data-testid="footer-follow-email"
                  className="w-9 h-9 rounded-xl bg-white/10 border border-white/20 text-white/80 flex items-center justify-center transition-all hover:bg-purple-500 hover:text-white hover:border-purple-500"
                >
                  <Mail className="w-4 h-4" />
                </a>
            </div>
          </div>

          {/* Bottom spacer so the help-desk widget never sits over the credits */}
          <div className="h-16 sm:h-0" aria-hidden="true"></div>
        </div>
      </div>
    </footer>
  );
}
